export default __webpack_public_path__ + "static/media/9.57c5c601.jpg";